module.exports = __webpack_public_path__ + "static/img/policyType5-banner.a983ff1b.png";